import { Card, Image, Stack } from "@mantine/core"
import logo from "~/assets/logo.svg"
import SignInForm from "~/features/sign-in/components/sign-in-form"

export default function SignIn() {
  return (
    <Stack h="100vh" justify="center" align="center" bg="#dee2e6">
      <Card px={50} py={70} shadow="sm" radius="lg" withBorder>
        <Image mb={50} fit="contain" src={logo} alt="logo" />
        <SignInForm />
      </Card>
    </Stack>
  )
}
